import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Inbox, Newspaper, ShieldCheck, LogOut, ExternalLink } from 'lucide-react';
import { company } from '../../mock/mock';
import EnquiriesPanel from './EnquiriesPanel';
import UpdatesPanel from './UpdatesPanel';
import CertificatesPanel from './CertificatesPanel';

const tabs = [
  { id: 'enquiries', label: 'Enquiries', icon: Inbox },
  { id: 'updates', label: 'Updates', icon: Newspaper },
  { id: 'certificates', label: 'Certificates', icon: ShieldCheck },
];

const AdminDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('enquiries');

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-ktc-cream/40">
      {/* Top bar */}
      <header className="bg-ktc-green text-ktc-ivory">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-ktc-ivory rounded-md px-3 py-2">
              <img src={company.logo} alt="KTC" className="h-8 w-auto object-contain" />
            </div>
            <div className="hidden sm:block">
              <div className="font-serif text-xl font-semibold leading-none">Admin Dashboard</div>
              <div className="text-xs text-ktc-ivory/60 mt-1">Manage enquiries, updates & certificates</div>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <a href="/" target="_blank" rel="noreferrer" className="hidden sm:inline-flex items-center gap-1.5 text-sm text-ktc-ivory/80 hover:text-ktc-goldLight"><ExternalLink size={15} /> View site</a>
            <div className="flex items-center gap-2.5">
              {user?.picture && <img src={user.picture} alt="" className="h-8 w-8 rounded-full object-cover border border-ktc-ivory/20" />}
              <span className="text-sm text-ktc-ivory/85 hidden md:inline">{user?.name || user?.email}</span>
            </div>
            <button onClick={handleLogout} className="inline-flex items-center gap-2 border border-ktc-ivory/25 hover:border-ktc-gold text-ktc-ivory text-sm px-4 py-2 rounded-md transition-colors"><LogOut size={15} /> Logout</button>
          </div>
        </div>
      </header>

      {/* Tabs */}
      <div className="bg-ktc-ivoryLight border-b border-ktc-cream sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6 flex gap-1">
          {tabs.map((t) => {
            const active = tab === t.id;
            return (
              <button key={t.id} onClick={() => setTab(t.id)} className={`inline-flex items-center gap-2 px-4 py-4 text-sm font-medium border-b-2 transition-colors ${active ? 'border-ktc-gold text-ktc-green' : 'border-transparent text-ktc-charcoal/60 hover:text-ktc-green'}`}>
                <t.icon size={17} /> {t.label}
              </button>
            );
          })}
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-6 py-8">
        {tab === 'enquiries' && <EnquiriesPanel />}
        {tab === 'updates' && <UpdatesPanel />}
        {tab === 'certificates' && <CertificatesPanel />}
      </main>
    </div>
  );
};

export default AdminDashboard;
